import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@utils/urls";
import { MatSelectChange } from '@angular/material/select';
import * as moment from 'moment';
import { DomSanitizer } from "@angular/platform-browser";
import { DownloadFileService } from "@shared/services/download-file.service";
import {jsPDF} from 'jspdf';
import html2canvas from 'html2canvas';
import { environment } from '../../../../environments/environment.prod'

@Component({
  selector: "app-interviews",
  templateUrl: "./interviews.component.html",
  styleUrls: ["./interviews.component.scss"],
})
export class InterviewsComponent implements OnInit {
  interviewList: any[];

  interviewMap: { [key: number]: object } = {};

  selectedInterviewId: number;

  pageUrl: string;

  isMobileView = false;

  public inProgress:boolean = false;

  constructor(private route: ActivatedRoute, 
              private apiService: ApiService,
              public sanitizer: DomSanitizer,
              public downloadFileService: DownloadFileService) {}

  ngOnInit() {
    this.readCEOInterview();
    this.pageUrl = location.href;
    this.route.queryParams.subscribe((qp) => {
      if (qp["interview-id"]) {
        this.selectedInterviewId = qp["interview-id"];
      }
    });
  }

  public readCEOInterview() {
    const obj = {
      type: "CEO-Interview",
    };
    this.apiService.postData(Urls.readArticles, obj).subscribe(
      (response) => {
        response.data.articles.forEach(article => {
          if(article.video){
            const link = "https://www.youtube.com/embed/";
            if(article.video.startsWith('https://www.youtube.com/watch?')){
              const embed = article.video.split("watch?v=")[1];
              article.video = link + embed;
              }else if(article.video.startsWith("https://youtu.be/")){
                const embed = article.video.split("https://youtu.be/")[1];
                article.video = link + embed;
              }
          }
          const diff = moment(article.modifiedDate, "DD-MM-YYYY, h:mm:ss").fromNow();
          article.translatedModifiedDate =  `${diff} . Updated`;
          this.interviewMap[article.id] = article;
        });
        this.interviewList = response.data.articles || [];
       
        // --- default setting
        if (this.interviewList[0] && !this.selectedInterviewId) {
          this.selectedInterviewId = this.interviewList[0].id;
        }
      },
      (error) => {}
    );
  }

  public downloadAsPDF(interviewData: any) {
    if(interviewData){
      const name = interviewData.split("/").pop();
      this.inProgress = true;
      this.downloadFileService.export(interviewData).subscribe(
        data=>{
          this.inProgress = false;
          const  url = window.URL.createObjectURL(data);
          //const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
  
      }, error=>{
        this.inProgress = true;
      });
      }
  }

  public investOnline() {
    if(!environment.isDRBuild){
      window.open("https://investonline.itiamc.com/", "_blank");
    }else{
      window.open("https://drinvestor.itiamc.com/", "_blank"); //DR-inv
    }
  }

  public onSelectionChange(change: MatSelectChange) {
    this.selectedInterviewId = change.value;
  }

  public getSafeUrl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public downloadFile(path, name){
    this.downloadFileService.export(path).subscribe(
      data => saveAs(data, name + `.pdf`)
    );
  };

}
